import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface PurchaseState {
  duration: Record<string, any>
  lessonNum: Record<string, any>
  packageOption: Record<string, any>
  availablePoint: number
  companyEducationId: number | null // New state for b2b2c_hr_round
  companyEducationProgramId: number | null
  setFilter: (payload: {
    duration: Record<string, any>
    lessonNum: Record<string, any>
    packageOption: Record<string, any>
  }) => void

  setAvailablePoint: (point: number) => void
  setCompanyEducationId: (id: number | null) => void // Setter function
  setCompanyEducationProgramId: (id: number | null) => void // Setter function
}

const usePurchaseStore = create<PurchaseState>()(
  persist(
    (set) => ({
      duration: {},
      lessonNum: {},
      packageOption: {},
      availablePoint: 0,
      companyEducationId: null, // Default value
      companyEducationProgramId: null,

      setFilter: ({ duration, lessonNum, packageOption }) =>
        set({
          duration,
          lessonNum,
          packageOption,
        }),

      setAvailablePoint: (point) =>
        set({
          availablePoint: point,
        }),

      setCompanyEducationId: (id) =>
        set({
          companyEducationId: id,
        }),

      setCompanyEducationProgramId: (id) =>
        set({
          companyEducationProgramId: id,
        }),
    }),
    {
      name: 'purchase-storage', // Key for local storage
      partialize: (state) => ({
        companyEducationId: state.companyEducationId,
        companyEducationProgramId: state.companyEducationProgramId,
      }), // Persist only companyEducationId
    }
  )
)
export default usePurchaseStore
